import React from "react";
import {
  Card,
  Col,
  Row,
  Form,
  Input,
  Button,
  Space,
  Select,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "components/MainLayout";

import useGet from "hooks/useGet";
import useUpdate from "hooks/useUpdate";
import useDelete from "hooks/useDelete";
import PageFailure from "components/PageFailure";
import ModalDelete from "components/ModalDelete";
import { useWorkers } from "context/providers/workers";
import useFormErrors from "hooks/useFormErrors";
import { special_characters_regexp } from "helpers/regexp";

const NoteUpdate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { all_users_list_options } = useWorkers();

  const [form] = Form.useForm();

  const path = `/notes/${id}`;

  const { is_loading, is_error, data, refetch } = useGet({
    path,
    query: ["notes", id],
  });

  const {
    pristine,
    has_error,
    onFieldsChange,
    setPristine,
  } = useFormErrors(data, form);

  const { is_saving, update } = useUpdate({
    path,
    form,
    onSuccess: async () => {
      await refetch();
      setPristine(true);
    },
  });

  const { is_deleting, _delete } = useDelete({
    path,
    onSuccess: () => navigate("/notes"),
  });

  if (is_error) {
    return (
      <PageFailure
        title="Nie znaleziono notatki"
        button_text="Wróć do listy"
        path="/notes"
      />
    );
  }
  return (
    <MainLayout
      back_href="/notes"
      breadcrumbs={[
        { name: "Notatki", path: "/notes" },
        { name: data?.id || "Trwa pobieranie..." },
      ]}
    >
      <Row>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Card title="Edytuj notatkę" loading={is_loading}>
            <Form
              form={form}
              layout="vertical"
              onFieldsChange={onFieldsChange}
              initialValues={{
                content: data?.content,
                user_id: data?.user_id,
              }}
              onFinish={(values) => update(values)}
            >
              <Form.Item
                label="Pracownik"
                name="user_id"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Pracownik jest wymagany!",
                  },
                ]}
              >
                <Select
                  placeholder="Pracownik"
                  options={all_users_list_options}
                  defaultValue={all_users_list_options?.find(
                    (id) => id === data?.user_id
                  )}
                />
              </Form.Item>
              <Form.Item
                label="Treść"
                name="content"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Treść jest wymagana!",
                  },
                  {
                    pattern: special_characters_regexp,
                    message:
                      "Pole zawiera niedozwolone znaki!!",
                  },
                ]}
              >
                <Input.TextArea
                  style={{ marginBottom: 10 }}
                  placeholder="Treść"
                  maxLength={400}
                  showCount={true}
                  rows={7}
                />
              </Form.Item>
              <Row justify="end">
                <Space>
                  <ModalDelete
                    loading={is_deleting}
                    text="notatkę"
                    handleDelete={_delete}
                  />
                  <Button
                    disabled={pristine || has_error}
                    loading={
                      is_deleting || is_loading || is_saving
                    }
                    type="primary"
                    htmlType="submit"
                  >
                    Zapisz
                  </Button>
                </Space>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </MainLayout>
  );
};

export default NoteUpdate;
